module.exports = __webpack_public_path__ + "biologic-grey-full.png";